import { isAxiosError } from "axios";

export function unpackRequestErrorMessage(error: unknown): string {
  if (isAxiosError(error)) {
    if (
      error.response?.data &&
      typeof error.response.data === "object" &&
      "error_message" in error.response.data
    ) {
      return error.response.data.error_message as string; // Here's an assumption for ya
    }

    if (error.message) {
      return error.message;
    }
  }

  if (error instanceof Error) {
    return error.message;
  }

  return "An unknown error occurred.";
}
